<!-- Banners sit above the content wrapper so they don't shift the title position -->
<div class="pre-content-banners">
    <!-- Pending Reviews Banner for Managers/Admins -->
    <div *ngIf="pending_review_count > 0 && is_manager_or_higher" class="review-banner review-banner-manager" data-testid="review-banner-manager">
        <div class="banner-content">
            <div class="banner-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
            </div>
            <div class="banner-text">
                <strong>{{ pending_review_count }} {{ pending_review_count === 1 ? 'document requires' : 'documents require' }} your review</strong>
                <span>Review document separations or classifications before they can be processed.</span>
            </div>
        </div>
        <a routerLink="/files/review" class="btn btn-primary btn-small" data-testid="btn-go-to-reviews">
            Review Now
        </a>
    </div>

    <!-- Pending Reviews Banner for Regular Users -->
    <div *ngIf="pending_review_count > 0 && !is_manager_or_higher" class="review-banner review-banner-user" data-testid="review-banner-user">
        <div class="banner-content">
            <div class="banner-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
            </div>
            <div class="banner-text">
                <span>{{ pending_review_count }} {{ pending_review_count === 1 ? 'file is' : 'files are' }} pending manager review</span>
            </div>
        </div>
    </div>
</div>

<div class="wrapper wrapper-medium" [class.has-banner]="pending_review_count > 0">

    <div class="header">
        <h1>Folders</h1>
        <p class="marto-10">Here you can easily find files by navigating through folders.</p>
    </div>

    <div *ngIf="isLoading" class="loading-indicator">
        <loading message="retrieving folders..."></loading>
    </div>

    <div *ngIf="!isLoading" class="file-list">
        <div *ngIf="categories.length === 0" class="empty-state">
            <p class="empty-state-message">No folders available</p>
        </div>

        <div *ngFor="let category of categories" class="folder-item" [class.expanded]="selectedCategoryId === category.category_id">
            <div class="folder-header" (click)="toggleCategory(category.category_id)">
                <div class="folder-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2" />
                    </svg>
                </div>
                <div class="folder-details">
                    <span class="folder-name">{{ category.category_name }}</span>
                </div>
                <div class="folder-actions">
                    <div class="file-count">
                        <span>{{ category.document_count }} {{ category.document_count === 1 ? 'file' : 'files' }}</span>
                    </div>
                    <div class="expand-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="selectedCategoryId === category.category_id">
                            <polyline points="6 9 12 15 18 9" />
                        </svg>
                    </div>
                </div>
            </div>

            <!-- Types container - only visible when category is selected -->
            <div class="types-container" *ngIf="selectedCategoryId === category.category_id">

                <div *ngIf="loadingTypes" class="types-loading">
                    <loading message="loading types..."></loading>
                </div>

                <div *ngIf="!loadingTypes && types.length === 0" class="types-empty">
                    <p>No document types available in this folder</p>
                </div>

                <div *ngIf="!loadingTypes && types.length > 0" class="types-list">
                    <div *ngFor="let type of types" class="type-item" [class.empty]="type.document_count === 0" [class.selected]="selectedTypeId === type.type_id">
                        <div class="type-header" (click)="$event.stopPropagation(); toggleType(type.type_id, type.document_count)">
                            <div class="type-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2" />
                                </svg>
                            </div>
                            <div class="type-details">
                                <span class="type-name">{{ type.type_name }}</span>
                            </div>
                            <div class="type-count">
                                <span>{{ type.document_count }} {{ type.document_count === 1 ? 'file' : 'files' }}</span>
                            </div>

                            <!-- Expand/collapse icon for types with files -->
                            <div *ngIf="type.document_count > 0" class="expand-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="selectedTypeId === type.type_id">
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </div>
                        </div>

                        <!-- Files list container - only visible when this type is selected -->
                        <div class="files-container" *ngIf="selectedTypeId === type.type_id">
                            <!-- Loading indicator for files -->
                            <div *ngIf="loadingFiles" class="files-loading">
                                <loading message="loading files..."></loading>
                            </div>

                            <!-- Empty state for files -->
                            <div *ngIf="!loadingFiles && files.length === 0" class="files-empty">
                                <p>No files found for this document type</p>
                            </div>

                            <!-- Files list -->
                            <div *ngIf="!loadingFiles && files.length > 0" class="files-list">
                                <h4 class="files-header">Files</h4>
                                <div *ngFor="let file of files" class="file-item" (click)="$event.stopPropagation(); selectFile(file.id)">
                                    <div class="file-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                            <polyline points="14 2 14 8 20 8" />
                                            <line x1="16" y1="13" x2="8" y2="13" />
                                            <line x1="16" y1="17" x2="8" y2="17" />
                                            <polyline points="10 9 9 9 8 9" />
                                        </svg>
                                    </div>
                                    <div class="file-details">
                                        <span class="file-name">{{ file.name }}</span>
                                        <span class="file-info">{{ file.extension.toUpperCase() || 'FILE' }} • {{ file.uploadedAt | date:'mediumDate' }}</span>
                                    </div>
                                </div>

                                <!-- Pagination -->
                                <div class="pagination-footer flex-row flex-center-y flex-space-between">
                                    <div class="pagination-info">
                                        <p>
                                            Showing {{ showingFrom }}–{{ showingTo }} of {{ totalFilesForType }} files
                                        </p>
                                    </div>
                                    <div class="pagination-controls flex-row flex-center-y">
                                        <button class="btn btn-secondary btn-small" (click)="firstPage()" [disabled]="currentPageForType === 1">
                                            « First
                                        </button>
                                        <button class="btn btn-secondary btn-small" (click)="prevPage()" [disabled]="currentPageForType === 1" style="margin-left: 6px;">
                                            ‹ Prev
                                        </button>
                                        <span style="margin: 0 8px;">Page {{ currentPageForType }} of {{ totalPages }}</span>
                                        <button class="btn btn-secondary btn-small" (click)="nextPage()" [disabled]="currentPageForType === totalPages || totalPages === 0" style="margin-right: 6px;">
                                            Next ›
                                        </button>
                                        <button class="btn btn-secondary btn-small" (click)="lastPage()" [disabled]="currentPageForType === totalPages || totalPages === 0">
                                            Last »
                                        </button>
                                        <div style="margin-left: 16px;" class="page-size">
                                            <label for="pageSize" style="margin-right: 6px;">Per page</label>
                                            <select id="pageSize" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                                                <option [ngValue]="10">10</option>
                                                <option [ngValue]="25">25</option>
                                                <option [ngValue]="50">50</option>
                                                <option [ngValue]="100">100</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- File Sidebar -->
                            <app-file-sidebar [fileId]="selectedFileId" [isOpen]="isSidebarOpen" (close)="closeSidebar()">
                            </app-file-sidebar>